/* Shared physical layout for the 3D scene, elevation and bill of materials. Metres. */
(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.GondoleLayout = api;
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  const PITCH = 0.05;
  const SLOT_ORIGIN = 0.032509;
  const SHELF_UNDERSIDE = 0.0197265;
  const SHELF_HEIGHT = 0.0436344;
  const FOOT_BEARING = 0.147904;
  const BRACKET_BEARING = 0.015;
  const BASE_Y = FOOT_BEARING - SHELF_UNDERSIDE;
  const BACK_Y = 0.16;
  const key = n => String(n).replace('.', '_');
  const section = g => g.H > 240 ? 8 : 6;
  const bracketType = g => g.P >= 57 ? '3h' : '2h';
  const faces = g => g.type === 'centrale' ? [1, -1] : [1];
  function panels(height) {
    let remaining = height - BACK_Y * 100;
    const result = [];
    for (const h of [40, 30, 20, 10]) {
      while (remaining >= h - 1e-6) { result.push(h); remaining -= h; }
    }
    return result;
  }
  function levels(g) {
    const result = [{ shelfY: BASE_Y, slot: null, hookY: null }];
    const minSlot = Math.ceil((FOOT_BEARING - SLOT_ORIGIN) / PITCH);
    const maxSlot = Math.floor((g.H / 100 - 0.02 - SHELF_HEIGHT + SHELF_UNDERSIDE - BRACKET_BEARING - SLOT_ORIGIN) / PITCH);
    for (let i = 1; i < g.nv; i++) {
      const slot = Math.round(minSlot + i * (maxSlot - minSlot) / (g.nv - 1));
      const hookY = SLOT_ORIGIN + slot * PITCH;
      result.push({ slot, hookY, shelfY: hookY + BRACKET_BEARING - SHELF_UNDERSIDE });
    }
    return result;
  }
  function pieces(g) {
    const out = [], L = g.L / 100, P = g.P / 100, halfPost = section(g) / 200;
    const add = (kind, model, x, y, z, rotation = 0, extra = {}) => out.push({ kind, model, x, y, z, rotation, ...extra });
    // Foot body starts ~15 mm in front of the rearmost hook. Anchor its body to the upright face.
    const footRear = {37: -0.17359219, 47: -0.22070052, 57: -0.26780885}[g.P];
    for (let i = 0; i <= g.N; i++) {
      add('montant', `montant-${section(g)}-${g.H}`, i * L, 0, 0);
      for (const dir of faces(g)) add('pied', `pied-${g.P}`, i * L, 0, dir * (halfPost - footRear), dir === 1 ? 0 : Math.PI);
    }
    for (let i = 0; i < g.N; i++) {
      for (const dir of faces(g)) {
        for (const level of levels(g)) {
          const rotation = dir === 1 ? 0 : Math.PI;
          add('tablette', `tablette-${key(g.L)}x${g.P}`, (i + 0.5) * L, level.shelfY, dir * (halfPost + P / 2), rotation);
          if (level.slot !== null) {
            for (const x of [i * L + 0.006, (i + 1) * L - 0.006])
              add('console', `console-${g.P}-${bracketType(g)}`, x, level.hookY, dir * halfPost, rotation, { slot: level.slot });
          }
        }
      }
      let y = BACK_Y;
      if (g.fond) for (const h of panels(g.H)) {
        add('fond', `fond-${key(g.L)}x${h}`, (i + 0.5) * L, y, 0);
        y += h / 100;
      }
    }
    return out;
  }
  function bill(g) {
    const nFaces = faces(g).length;
    const rows = [
      {label:`Montant ${g.H} cm · section ${section(g)}`,key:`MT-${g.H}-S${section(g)}`,qty:g.N+1},
      {label:`Pied ${g.P} cm`,key:`PD-${g.P}`,qty:(g.N+1)*nFaces},
      {label:`Tablette ${g.L} × ${g.P} cm`,key:`TS-${g.L}x${g.P}`,qty:g.N*g.nv*nFaces},
      {label:`Console ${g.P} cm · ${bracketType(g).toUpperCase()}`,key:`CN-${g.P}-${bracketType(g).toUpperCase()}`,qty:g.N*(g.nv-1)*2*nFaces}
    ];
    if (g.fond) {
      const counts = {};
      for (const h of panels(g.H)) counts[h] = (counts[h] || 0) + g.N;
      for (const h of [40,30,20,10]) if (counts[h]) rows.push({label:`Fond lisse ${g.L} × ${h} cm`,key:`DS-${g.L}x${h}`,qty:counts[h]});
    }
    return rows.filter(row => row.qty > 0);
  }
  return {PITCH, SLOT_ORIGIN, SHELF_UNDERSIDE, SHELF_HEIGHT, FOOT_BEARING, BRACKET_BEARING, BASE_Y, BACK_Y, section, faces, panels, levels, pieces, bill};
});
